import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["MeasuringPointAttachment"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getMeasuringPointAttachmentByMeasuringPoint: build.query<
        GetMeasuringPointAttachmentByMeasuringPointApiResponse,
        GetMeasuringPointAttachmentByMeasuringPointApiArg
      >({
        query: (queryArg) => ({ url: `/MeasuringPointAttachment/${queryArg}` }),
        providesTags: ["MeasuringPointAttachment"],
      }),
      getMeasuringPointAttachmentDateiById: build.query<
        GetMeasuringPointAttachmentDateiByIdApiResponse,
        GetMeasuringPointAttachmentDateiByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/MeasuringPointAttachment/Datei/${queryArg}`,
        }),
        providesTags: ["MeasuringPointAttachment"],
      }),
      deleteMeasuringPointAttachmentDateiById: build.mutation<
        DeleteMeasuringPointAttachmentDateiByIdApiResponse,
        DeleteMeasuringPointAttachmentDateiByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/MeasuringPointAttachment/Datei/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["MeasuringPointAttachment"],
      }),
      postMeasuringPointAttachment: build.mutation<
        PostMeasuringPointAttachmentApiResponse,
        PostMeasuringPointAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/MeasuringPointAttachment`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["MeasuringPointAttachment"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as measuringPointAttachmentApi };
export type GetMeasuringPointAttachmentByMeasuringPointApiResponse =
  /** status 200 OK */ MeasuringPointAttachmentDto[];
export type GetMeasuringPointAttachmentByMeasuringPointApiArg = string;
export type GetMeasuringPointAttachmentDateiByIdApiResponse =
  /** status 200 OK */ string;
export type GetMeasuringPointAttachmentDateiByIdApiArg = number;
export type DeleteMeasuringPointAttachmentDateiByIdApiResponse = unknown;
export type DeleteMeasuringPointAttachmentDateiByIdApiArg = number;
export type PostMeasuringPointAttachmentApiResponse =
  /** status 201 Created */ MeasuringPointAttachmentUploadDto;
export type PostMeasuringPointAttachmentApiArg = MeasuringPointAttachmentDto;
export type MeasuringPointAttachmentDto = {
  id: number;
  name: string;
  measuringPoint: string;
  creationDate: string;
  description?: string | null;
  licenseKey?: string | null;
};
export type MeasuringPointAttachmentUploadDto = {
  url: string;
  id: number;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export const {
  useGetMeasuringPointAttachmentByMeasuringPointQuery,
  useLazyGetMeasuringPointAttachmentByMeasuringPointQuery,
  useGetMeasuringPointAttachmentDateiByIdQuery,
  useLazyGetMeasuringPointAttachmentDateiByIdQuery,
  useDeleteMeasuringPointAttachmentDateiByIdMutation,
  usePostMeasuringPointAttachmentMutation,
} = injectedRtkApi;
